// Japanese — top-level translations. Falls back to English for missing keys.
import en from "./en";

const ja = {
  ...en,
  ui: {
    ...en.ui,
    brand: "My World Quest",
    brand_subtitle: "ぬりえと まなび",
    nav: {
      home: "ホーム", countries: "国", globe: "地球", continents: "大陸",
      color: "ぬりえ", puzzles: "パズル", games: "ゲーム", math: "ちりさんすう",
      quiz: "クイズ", parents: "ほごしゃ", more: "もっと",
     "geo-lines": "世界の線", "maths-academy": "マスアカデミー",},
    accessibility: { bigText: "おおきな文字", highContrast: "高コントラスト" },
    navGroups: { quick: "クイック", explore: "探検", play: "遊んで学ぶ", collect: "コレクション", adv: "冒険", grownup: "大人向け" },
    actions: { back: "もどる", close: "とじる", reset: "リセット", save: "ほぞん", retry: "もう一回", playAgain: "もう一回あそぶ" },
  },
  microcopy: {
    ...en.microcopy,
    great: "よくできました! ⭐",
    correct: "✅ せいかい！",
    nope: "もういちど！",
    tryAgain: "あとちょっと。がんばって！",
    awesome: "すごい！",
    welcome: "{{country}}へようこそ！{{language}}を まなびましょう。",
    youDidIt: "やったね！",
    perfect: "かんぺき！",
  },
  home: {
    ...en.home,
    title1: "世界を探検しよう",
    title2: "ひとつずつ国を",
    subtitle: "楽しい地理アドベンチャー、クイズ、チャレンジ、ごほうびで、子どもたちが国、文化、旗、ランドマークなどを発見するお手伝い。",
    playNow: "あそぶ →",
    takeQuiz: "クイズをやる",
    openGlobe: "大きい地球を ひらく →",
    globeHint: "ひかるピンを タップして 国を おぼえよう！",
    popularCountries: "または はたを タップ",
    whatNext: "きょうは なにを する？",
    whatNextSub: "どれでもいいよ。ぜんぶ たのしい！",
    tiles: {
      ...en.home.tiles,
      learn: "国を まなぶ", learnDesc: "30か国の はた！",
      globe: "3D 地球", globeDesc: "まわして タップ！",
      continents: "大陸", continentsDesc: "7つの大陸を たんけん",
      color: "ぬりえ", colorDesc: "エッフェル塔を ぬろう！",
      math: "ちりさんすう", mathDesc: "kmをたす、国をかぞえる！",
      quiz: "クイズ", quizDesc: "やさしい・むずかしい",
      parents: "ほごしゃの方へ", parentsDesc: "おこさまの しんちょく",
    },
  },
  learn: {
    title: "国を まなぶ", capital: "首都", language: "言語", hello: "こんにちは",
    learnIt: "おぼえた！", listen: "きく",
    goalsEyebrow: "きょうの がくしゅう もくひょう",
    goalsHeading: "🎯 まずは これから！",
    goalsSubtitle: "{{tier}}さいで まず おぼえたい 4つの こと — カリキュラムから えらびました。",
    goalsAllTopics: "ぜんぶの トピックを みる",
    goalsLearnNow: "いま まなぶ",
    goalsKey: "だいじ #{{n}}",
    topicTitles: {
      "art-design": "え、ペイント と デザイン",
      "music": "おんがく：リズム、うた、がくふ",
      "computing-code": "コード、アルゴリズム、ネット あんぜん",
      "physical-education": "たいいく、けんこう、フィットネス",
      "world-religions": "せかいの しゅうきょう と しんじる こと",
      "wellbeing-relationships": "けんこう、きもち、ともだち",
    },
  },
  globe: {
    title: "3D 地球", subtitle: "まわして タップ！",
    learnLang: "ことばを まなぶ", moreInfo: "もっと しりたい", learnedTag: "✓ おぼえた",
    spinTap: "地球を まわして 国を タップ！", spinTapSub: "ピンを タップで くわしく。",
  },
  quiz: {
    title: "クイズ", basic: "やさしい", advanced: "むずかしい",
    start: "クイズを はじめる", next: "つぎへ →", finish: "おわり！", score: "とくてん",
  },
  stickers: { title: "わたしの シールアルバム", subtitle: "ぜんぶの ゲームで シールを あつめよう！" },
  langSwitcher: {
    label: "げんご",
    english: "English", french: "Français", hindi: "हिन्दी", arabic: "العربية",
    italian: "Italiano", spanish: "Español", mandarin: "中文", japanese: "日本語", korean: "한국어", swahili: "Kiswahili",
  },
  common: {
    whereToNext: "次はどこへ？",
    home: "ホーム",
    earnMoreStars: "⭐ もっと星をゲット",
    earnHowTo: "クイックゲームで遊ぼう — それぞれXPがもらえるよ！",
    pickAge: "年齢を選ぶ",
    ages: "年齢",
    startExploring: "探検をはじめる",
    pickAnywhere: "上から選んでね — またはタップ！",
    tapAnyCountry: "国をタップしてその物語を見つけよう！",
    exploreGlobe: "地球を探検",
    exploreGlobeSub: "フルスクリーン 3D 冒険",
  },
  shortcuts: {
    home: "ホーム",
    continents: "大陸",
    globe: "地球",
    ask: "聞く",
    landmarks: "ランドマーク",
    flags: "旗",
    pixel: "ピクセル",
    puzzles: "パズル",
    math: "算数",
    trip: "旅",
    quiz: "クイズ",
    quests: "クエスト",
    stickers: "ステッカー",
    miniGames: "ミニゲーム",
    geoMath: "地理算数",
    quickQuiz: "クイッククイズ",
    myTrophies: "わたしのトロフィー",
    colorCreate: "ぬり絵＆クリエイト",
    spinGlobe: "地球をまわそう",
    askGlobe: "地球にきいてみよう",
    dreamTrip: "夢の旅",
    earnStars: "星を集める",
    tryAQuest: "クエストに挑戦",
    playAgain: "もう一回",
    learnCountry: "国を覚える",
    colorLandmark: "ランドマークを塗る",
    learnCountries: "国を学ぶ",
    advanced: "上級モード",
    spellCountry: "国の名前を書こう",
    advancedHub: "上級コーナー",
    squishyHop: "スクイッシーホップ",
    mathSnap: "マススナップ",
    language: "言語",
    geoLines: "世界の線",
  },
  coloringExtra: {
    modeLandmarks: "ランドマーク",
    modeFlags: "旗のアーティスト",
    modePixel: "ピクセルアート",
    diffEasy: "やさしい",
    diffMedium: "ふつう",
    diffExpert: "じょうきゅう",
    difficultyLabel: "むずかしさ:",
  },
  tilesExtra: {
    labelLearn: "まなぶ",
    labelCreate: "つくる",
    labelPlay: "あそぶ",
    labelTrophies: "トロフィー",
    whatNextSub: "なんでも選んでね — ぜんぶたのしいよ！",
  },
  pills: {
    orTry: "それとも ↓",
    
    squishyHop: "スクイッシーホップ",
    mathSnap: "算数スナップ",colorLandmark: "ランドマークを塗る",
    solvePuzzle: "パズルを解く",
    dreamTrip: "夢の旅を計画",
    geoMath: "地理算数",
    continentQuests: "大陸クエスト",
    stickerBook: "ステッカー帳",
    famousPeople: "有名人に会う",
    culturalSpot: "文化スポット",
    quickQuiz: "クイッククイズ",
    continentMaps: "大陸の地図",
    spellCountry: "国の名前を書こう",
    flagArtist: "国旗アーティスト",
    pixelArt: "ピクセルアート",
    spinGlobe: "地球をまわそう",
    askGlobe: "地球にきいてみよう",
    myTrophies: "わたしのトロフィー",
    advancedHub: "上級コーナー",
    geoLines: "世界の線",
  },
  canvas: {
    tools: "ツール",
    brushSize: "ブラシサイズ",
    colors: "色",
    patterns: "パターン",
    modes: "モード",
    solid: "ベタ",
    anyColor: "好きな色",
    recent: "最近",
    sticker: "ステッカー",
    symmetry: "シンメトリー",
    colorByNumber: "数字で塗る",
    reference: "見本",
    undo: "もどる",
    redo: "やり直し",
    reset: "リセット",
    replay: "リプレイ",
    check: "チェック",
    save: "保存",
    fill: "ぬる",
    pencil: "えんぴつ",
    stamp: "スタンプ",
    erase: "けす",
    on: "オン",
    off: "オフ",
    tool: "ツール:",
    pattern: "パターン:",
    printOne: "プリント",
    downloadAll: "全部ダウンロード",
    appTitle: "ぬり絵＆クリエイト 🎨",
    appSub: "ブラシ、パターン、ステッカー、数字でぬり絵などなど！",
  },
};

export default ja;
